import React, { useState } from 'react';
import Select from 'react-select';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Spinner from 'react-bootstrap/Spinner';
import STATUS from '../../utils/constants/statusConstants';

const ModalTranslateLesson = ({ onHide, onTranslate, onView, languageSelected, onLanguageChange, status, lessonId, lessonLangCode, ...props }) => {
  const [languages, setLanguages] = useState([
      { label: 'English', value: 'en' },
      { label: 'Spanish', value: 'es' }
  ]);
  
  const availableLanguages = languages.filter(
    (lang) => lang.value !== lessonLangCode?.toLowerCase()
  );

  return (
    <Modal
      {...props}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <FormattedMessage id="modal-translate-lesson-title" /> {lessonId}
        </Modal.Title>
      </Modal.Header>

      {status === STATUS.IDLE && (
        <Modal.Body>
          <h4><FormattedMessage id="modal-translate-lesson-body" /></h4>
          <p>
            <FormattedMessage id="modal-translate-lesson-instructions" />
          </p>
          <Select
            value={languageSelected}
            onChange={(selected) => onLanguageChange(selected)}
            options={availableLanguages}
            placeholder={<FormattedMessage id="modal-translate-placeholder" />}
          />
        </Modal.Body>
      )}
      {status === STATUS.TRANSLATING && (
        <Modal.Body>
          <div className="d-flex align-items-center gap-3">
            <Spinner className="mr-3" animation="border" role="status" />
            <h4><FormattedMessage id="modal-translate-process-body" /></h4>
          </div>
          <p>
            <FormattedMessage id="modal-translate-process-instructions" />
          </p>
        </Modal.Body>
      )}
      {status === STATUS.ERROR && (
        <Modal.Body>
          <h4><FormattedMessage id="modal-translate-error-body" /></h4>
          <p>
            <FormattedMessage id="modal-translate-error-instructions" />
          </p>
        </Modal.Body>
      )}
      {status === STATUS.SUCCESS && (
        <Modal.Body>
          <h4><FormattedMessage id="modal-translate-success-body" /></h4>
          <p>
            <FormattedMessage id="modal-translate-success-instructions" />
          </p>
        </Modal.Body>
      )}

      {status === STATUS.IDLE && (
        <Modal.Footer>
          <Button
            variant="primary"
            type="button"
            disabled={!languageSelected}
            onClick={onTranslate}><FormattedMessage id="ls-translate" />
          </Button>
          <Button
            variant="danger"
            type="button"
            onClick={onHide}><FormattedMessage id="ls-close" />
          </Button>
          </Modal.Footer>
      )}
      
      {status === STATUS.SUCCESS && (
        <Modal.Footer>
          <Button
            variant="primary"
            type="button"
            onClick={onView}><FormattedMessage id="lt-view-lesson" />
          </Button>
          <Button
            variant="danger"
            type="button"
            onClick={onHide}><FormattedMessage id="ls-close" />
          </Button>
          </Modal.Footer>
      )}
      
      {status === STATUS.ERROR && (
        <Modal.Footer>
          <Button
            variant="primary"
            type="button"
            onClick={onTranslate}><FormattedMessage id="lt-retry-translate-lesson" />
          </Button>
          <Button
            variant="danger"
            type="button"
            onClick={onHide}><FormattedMessage id="ls-close" />
          </Button>
          </Modal.Footer>
        )}
    </Modal>
  );
};

export default ModalTranslateLesson;